import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";

const EditTaskModal = ({
  show,
  handleClose,
  handleUpdate,
  selectedRecord,
  handleShowDelete
}) => {
  const [repAccess, setRepAccess] = useState("0");

  useEffect(() => {
    if (selectedRecord) {
      setRepAccess(selectedRecord.rep_access ? "1" : "0");
    }
  }, [selectedRecord]);

  const onUpdate = () => {
    handleUpdate({  repAccess: repAccess === "1"});
  };

  const onModelClose = () => {
    handleClose();
    setRepAccess('0');
  };

  const handleRemove = () => {
    handleShowDelete(selectedRecord);
    onModelClose();
  };

  const getTaskName = (record) => {
    let cate_name = record && record.task && record.task.category ? record.task.category.name : "N/A";
    if(cate_name !== "N/A"){
      cate_name += " / ";
    }

    return record && record.task ? cate_name + record.task.name : "";
  }

  return (
    <Modal
      show={show}
      onHide={onModelClose}
      centered
      className="edit-task-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4 className="font-16 font-weight-bold">Edit Task</h4>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Category / Task */}
        <Form.Group className="mb-3">
          <Form.Label className="label-input">Task</Form.Label>
          <Form.Control
            type="text"
            className="input-field"
            value={getTaskName(selectedRecord)}
            disabled
          />
        </Form.Group>

        {/* Rep Access */}
        <Form.Group className="mb-3">
          <Form.Label className="label-input">Rep Access</Form.Label>
          <Form.Select
            className="input-field"
            value={repAccess}
            onChange={(e) => setRepAccess(e.target.value)}
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="d-inline">
        <Row>
          <Col>
            <button
              variant="none"
              className="remove-btn w-100"
              onClick={() => handleRemove(selectedRecord)}
            >
              Remove  
            </button>
          </Col>
          <Col>
            <button
              variant="none"
              className="c-b-btn w-100"
              onClick={onModelClose}
            >
              Cancel
            </button>
          </Col>
          <Col>
            <button variant="none" className="n-u-btn w-100" onClick={onUpdate}>
              Update
            </button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default EditTaskModal;

